import { graphql } from "gatsby";
import React from "react";
import { BackgroundColor } from "@silversea-ssc/ui-components-react";
import { PageBuilderInlineLeadFormFragment } from "types/graphql-types";
import PageBuilderSectionTitle from "./PageBuilderSectionTitle";
import InlineLeadForm from "components/InlineLeadForm/InlineLeadForm";
import { isPresent } from "src/utils/checks";
import { FormRequestType } from "src/ssc-api/leadAPIClient";

type Props = PageBuilderInlineLeadFormFragment & {
  backgroundColor: BackgroundColor;
};

const PageBuilderInlineLeadForm: React.FC<Props> = ({
  backgroundColor,
  heading,
  askPhoneNumber,
  requestSource,
  requestType,
  thankYouContent,
  backgroundImage,
  formDisclaimerContent
}) => {
  if (!isPresent(requestType) || !isPresent(requestSource)) return null;

  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      <InlineLeadForm
        askPhone={!!askPhoneNumber}
        requestType={requestType as FormRequestType}
        requestSource={requestSource}
        formName="PageBuilderInlineLeadForm"
        dataContentName="page_builder_inline_lead_form"
        thankYouContentTitle={thankYouContent?.title?.localized}
        thankYouContentText={thankYouContent?.content?.localized}
        image={backgroundImage}
        inputColor={backgroundColor == "white" ? "neutral05" : "white"}
        formDisclaimerContent={formDisclaimerContent}
      />
    </React.Fragment>
  );
};

export default PageBuilderInlineLeadForm;

export const fragments = graphql`
  fragment PageBuilderInlineLeadForm on SanityInlineLeadForm {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    heading {
      ...SectionTitle
    }
    backgroundImage {
      ...ImageWithAlt
    }
    thankYouContent {
      title {
        localized
      }
      content {
        localized
      }
    }
    requestType
    requestSource
    askPhoneNumber
    formDisclaimerContent: formDisclaimer {
      ...FormDisclaimer
    }
  }
`;
